import { f7, useStore } from 'framework7-react';
import { FC, useState } from 'react';
import style from './ReservationHistoryPageStyle.module.css';
import { ReservationItem } from '@/components/projects/ReservationItem/ReservationItem';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { serviceType, statusReservation } from '@/consts/reservation';
import { useFetchReservationHistories } from '@/hooks/api/reservation/useFetchReservationHistories';
import { Car } from '@/types/api/customerApi';
import { Reservation } from '@/types/api/reservationApi';

const STATUS_CANCEL = statusReservation.CANCEL;

type TabKey = 'active' | 'history';

// 「進行中」とみなすステータスは明示的に許可リストで定義する。
// 未知のステータス（NOT_ACCEPT 等の終了系）が誤って進行中に紛れないようデフォルトを履歴側に倒す。
const ACTIVE_STATUSES: number[] = [
  statusReservation.TENTATIVE,
  statusReservation.CONFIRMED,
];
const isActive = (r: Reservation) => ACTIVE_STATUSES.includes(r.status);

export const ReservationHistoryPage: FC = () => {
  const selectedCar = useStore(store, 'carItemInfo') as Required<Car>;
  const { m_customer_id } = store.state.authInfo;
  const { bp_flg } = store.state.customerInfo;
  const [tab, setTab] = useState<TabKey>('active');

  const { data } = useFetchReservationHistories({
    m_customer_id,
    t_stock_car_id: selectedCar.t_stock_car_id,
  });

  const allowed = (data ?? []).filter(
    (r: Reservation) => !(r.service_type === serviceType.body_paint && !bp_flg),
  );
  const visible = allowed.filter((r) =>
    tab === 'active' ? isActive(r) : !isActive(r),
  );

  return (
    <PageTemplate
      pageName="WashHistory"
      title="過去の予約一覧"
      showNavBack
      handleClickBack={() =>
        f7.view.main.router.navigate(paths.maintenance, {
          transition: 'push-reverse',
        })
      }
    >
      <div className={style['reservation-history-title']}>
        <p className={style['reservation-history-title__text']}>
          過去の予約一覧
        </p>
        <p className={style['reservation-history-title__desc']}>
          支払い済みの領収書は各予約詳細から確認することができます。
        </p>
      </div>
      <div className={style['tabs']} role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'active'}
          className={`${style['tab']} ${
            tab === 'active' ? style['tab--active'] : ''
          }`}
          onClick={() => setTab('active')}
        >
          進行中
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'history'}
          className={`${style['tab']} ${
            tab === 'history' ? style['tab--active'] : ''
          }`}
          onClick={() => setTab('history')}
        >
          履歴
        </button>
      </div>
      <div className={style['card']}>
        {visible.length === 0 ? (
          <div className={style['empty']}>
            {tab === 'active'
              ? '進行中の予約はありません。'
              : '履歴はありません。'}
          </div>
        ) : (
          visible.map((reservation: Reservation, i: number) => (
            <div
              key={i}
              className={
                reservation.status === STATUS_CANCEL
                  ? style['item--canceled']
                  : undefined
              }
            >
              <ReservationItem reservation={reservation} />
            </div>
          ))
        )}
      </div>
    </PageTemplate>
  );
};
